import { useState } from "react";
import {
  HashedDynamicPermission,
  HashedPermission,
  resolveAssetUrl,
  routes,
} from "@songtradr-one/shared-common";
import { useAppContext } from "@songtradr-one/shared-frontend";
import { LogoLink, OrgLogo, OrgName } from "./Branding.Parts";

export const Branding = () => {
  const { hasAnyPermission, currentOrg, appConfig } = useAppContext();

  const [overrideToFallbackLogo, setOverrideToFallbackLogo] = useState(false);

  const logoLink =
    window.location.pathname === routes.portal.base
      ? hasAnyPermission([
          HashedPermission.SYSTEM_ROOT,
          HashedDynamicPermission.MULTI_ORG_ACCESS,
        ])
        ? routes.orgs.base
        : ""
      : routes.portal.base;

  return appConfig.branding?.logo && !overrideToFallbackLogo ? (
    <LogoLink to={logoLink} $disabled={!logoLink}>
      <OrgLogo
        src={resolveAssetUrl(appConfig.assetsUrl, appConfig.branding.logo)}
        alt={`${currentOrg?.name ?? "Organization"} Logo`}
        onError={() => setOverrideToFallbackLogo(true)}
      />
    </LogoLink>
  ) : (
    <OrgName to={logoLink} $disabled={!logoLink}>
      {currentOrg?.name ? currentOrg.name : appConfig.appNavLogo}
    </OrgName>
  );
};
